import { useState } from 'react';
import ButtonYellow from '../../Atoms/ButtonYellow/ButtonYellow';
import ModalGeneral from '../../Modals/ModalGeneral/ModalGeneral';

const RegisterUser = ({
  parameters,

  disabled,

  setShowEnrrolmentForm
}) => {
  const [messageModal, setMessageModal] = useState({ title: null, subtitle: null });
  const [modalSucces, setModalSucces] = useState(false);
  const [modalError, setModalError] = useState(false);

  return (
    <>
      <ModalGeneral
        success
        isShow={modalSucces}
        handleShow={() => {
          setModalSucces(false);
          setShowEnrrolmentForm(false);
        }}
        confirm={parameters?.ACCEPT_MODAL?.value}
        onClickConfirm={() => {
          setModalSucces(false);
          setShowEnrrolmentForm(false);
        }}
        title={messageModal?.title ?? parameters?.INF_MSG_53?.value}
        subtitle={messageModal?.subtitle ?? parameters?.TXT_MSG_REG?.value}
      />
      <ModalGeneral
        warning
        isShow={modalError}
        handleShow={() => {
          setModalError(false);
          setShowEnrrolmentForm(false);
        }}
        confirm={parameters?.ACCEPT_MODAL?.value}
        onClickConfirm={() => {
          setModalError(false);

          setShowEnrrolmentForm(false);
        }}
        title={parameters?.INF_MSG_55?.value}
        subtitle={messageModal.subtitle ?? parameters?.INF_MSG_55?.description_value}
      />

      <div className="py-0 mt-0 text-center">
        <ButtonYellow
          disabled={disabled}
          ifispress={() => setShowEnrrolmentForm(true)}
          title={parameters?.SUCCES_CREDIT?.value}
          className="px-2 mx-0"
        />
      </div>
    </>
  );
};

export default RegisterUser;
